/** Path segments for nested `navPaths.paths` messages (slashes only — no `.` in segment keys). */
export function hrefToNavPathSegments(href: string): string[] {
  return href.replace(/^\//, '').replace(/\/$/, '').split('/').filter(Boolean);
}

/** Dot path for `useTranslations('navPaths.paths')` nested lookup, e.g. `services.full-cycle`. */
export function hrefToNavPathKey(href: string): string {
  return hrefToNavPathSegments(href).join('.');
}

/** Nested self label when a path node has children (`services.full-cycle` → `services.full-cycle.__`). */
export function navPathSelfMessageKey(pathKey: string): string {
  return `${pathKey}.__`;
}

/** @deprecated Use {@link navPathSelfMessageKey} with {@link hrefToNavPathKey}. */
export function hrefToNavPathSelfKey(href: string): string {
  return navPathSelfMessageKey(hrefToNavPathKey(href));
}
